export default __webpack_public_path__ + "static/map_box-c693c41981c11b916395ddd7db7afc7a.png";